import { render, staticRenderFns } from "./OpenBankingBankDescription.vue?vue&type=template&id=3d91f8b5&scoped=true"
import script from "./OpenBankingBankDescription.vue?vue&type=script&lang=js"
export * from "./OpenBankingBankDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d91f8b5",
  null
  
)

export default component.exports